import { useAppSelector } from "../app/hooks";

interface Props {
	link: string;
	className?: string;
}

export default function SwitchToLegacy(props: Props) {
	const { aspUrl, config } = useAppSelector((state) => state.site);

	return (
		<section className={`min-h-full justify-center py-8 sm:px-6 lg:px-8 ${props.className}`}>
			<div className="text-center">
				<a
					id="return-to-classic-link"
					href={`${aspUrl}${props.link}`}
					onClick={() => sessionStorage.setItem("prefersSpa", "false")}
					className="text-lg text-primary-700 hover:text-primary-600 text-center">
					Want to return to {config?.siteName} Classic?
				</a>
			</div>
		</section>
	);
}
